import { render } from "./DashboardComp.vue?vue&type=template&id=85a4af54"
import script from "../dash.js?vue&type=script&lang=js&external"
export * from "../dash.js?vue&type=script&lang=js&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__